import './index.scss';

import { Drawer } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { CButton } from '@/components/CButton';
import { Icon } from '@/components/Icon';
import { toggleMobileSidebar } from '@/core/redux/themeSettingsSlice';
import type { AppDispatch, RootState } from '@/store/store';
import type { NavItem } from '../navigation';
import { Sidebar } from '../Sidebar';

const MOBILE_NAVIGATION_WIDTH = 320;

type MobileNavigationProps = {
  /** The drawer is only used while the viewport forces the icon rail or hides the sidebar. */
  enabled: boolean;
  items: NavItem[];
  accountItem?: NavItem;
  onOpenUpdates: () => void;
  onOpenSupport: () => void;
};

export const MobileNavigation = ({
  enabled,
  items,
  accountItem,
  onOpenUpdates,
  onOpenSupport,
}: MobileNavigationProps) => {
  const { t } = useTranslation(['common', 'sidebar-menu']);
  const dispatch = useDispatch<AppDispatch>();
  // The persisted flag is named `isMobileSidebarOpen` but has always meant "hidden".
  const isOpen = !useSelector((state: RootState) => state.theme.isMobileSidebarOpen);

  const handleClose = () => {
    if (isOpen) {
      dispatch(toggleMobileSidebar());
    }
  };

  return (
    <Drawer
      rootClassName="c-mobile-navigation"
      placement="left"
      width={MOBILE_NAVIGATION_WIDTH}
      closable={false}
      title={t('sidebar-menu:sidebar-menu.menu')}
      extra={
        <CButton
          iconOnly
          variant="ghost"
          className="c-mobile-navigation__close"
          startIcon={<Icon name="close" size={16} strokeWidth={2} />}
          aria-label={t('common:common.close_navigation')}
          onClick={handleClose}
        />
      }
      open={enabled && isOpen}
      onClose={handleClose}
    >
      <Sidebar
        items={items}
        accountItem={accountItem}
        onNavigate={handleClose}
        onOpenUpdates={onOpenUpdates}
        onOpenSupport={onOpenSupport}
      />
    </Drawer>
  );
};
